// Stripe Price Configuration
// Replace these with your actual Stripe Price IDs from the Stripe Dashboard

export const STRIPE_PRICE_IDS = {
  // Test mode price IDs (price_xxx format)
  basic: {
    monthly: process.env.NEXT_PUBLIC_STRIPE_BASIC_PRICE_ID || 'price_basic_monthly',
    yearly: process.env.NEXT_PUBLIC_STRIPE_BASIC_YEARLY_PRICE_ID || 'price_basic_yearly'
  },
  premium: {
    monthly: process.env.NEXT_PUBLIC_STRIPE_PREMIUM_PRICE_ID || 'price_premium_monthly',
    yearly: process.env.NEXT_PUBLIC_STRIPE_PREMIUM_YEARLY_PRICE_ID || 'price_premium_yearly'
  }
} as const;

// Product metadata for fallback display
export const STRIPE_PRODUCTS = {
  basic: {
    name: 'Basic',
    description: 'Perfect for individual learners',
    price: 999, // $9.99 in cents
    interval: 'month' as const,
    features: [
      'Unlimited transcript generation',
      'AI summaries & mind maps',
      'Basic vocabulary analysis',
      'Export to PDF/Text',
      'Email support'
    ]
  },
  premium: {
    name: 'Premium',
    description: 'Best for serious language learners',
    price: 1999, // $19.99 in cents
    interval: 'month' as const,
    features: [
      'Everything in Basic, plus:',
      'Advanced vocabulary tracking',
      'Shadowing practice mode',
      'TOEFL vocabulary detection',
      'Custom vocabulary lists',
      'Priority processing',
      'Advanced analytics',
      'Priority support'
    ]
  }
} as const;

// Helper to get the correct price ID based on plan and interval
export function getStripePriceId(plan: 'basic' | 'premium', interval: 'monthly' | 'yearly' = 'monthly'): string {
  return STRIPE_PRICE_IDS[plan][interval];
}